/**
 * Chat-related constants shared between web and mobile
 */
export const MESSAGE_TYPES = {
    USER: 'user',
    BOT: 'bot',
    AGENT: 'agent',
    CLAIRE: 'claire',
};
export const CONTENT_TYPES = {
    MULTIPLE_CHOICE: 'multiple_choice',
    INFO_CARD: 'info_card',
    TEXT: 'text',
    LISTINGS: 'listings',
    LOADING: 'loading',
    TRANSITION: 'transition',
    MEDIA: 'media',
    // Placeholder value: the backend hasn't named this content type yet. Web and
    // mobile both switch on the constant, so swapping the string is enough.
    DOCUMENT_REQUEST: 'document_request',
    // An already uploaded file, shown read-only. Kept separate from MEDIA, which
    // stays the generic image/video type.
    DOCUMENT_VIEW: 'document_view',
    // Control frame rather than a message, like LOADING: tells the client to drop
    // `relatedBotMessageId` from the transcript. Never rendered.
    MESSAGE_DELETED: 'message_deleted',
};
export const MESSAGE_STATUS = {
    SENDING: 'sending',
    SENT: 'sent',
    FAILED: 'failed',
};
/**
 * Which call to action opened the chat, sent on chat creation so the backend can
 * pick the matching opening script. The two tour values line up with
 * `UnitTourHighlight`, so a highlight can be passed straight through.
 */
export const CHAT_TOUR_TYPES = {
    /** The plain "Schedule a tour" button. */
    SCHEDULE_TOUR: 'schedule_tour',
    OPEN_HOUSE: 'open_house',
    VIDEO_TOUR: 'video_tour',
};
